import { Chip } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";

export default function Coffee(isMapLoaded) {
  const [removeCoffee, setRemoveCoffee] = useState(false);

  const handleRemoveCoffee = () => {
    setRemoveCoffee(true);
  };

  const handleClick = () => {
    window.open("https://www.buymeacoffee.com/magicberrylabs", "_blank");
  };

  return isMapLoaded && !removeCoffee ? (
    <Box
      sx={{
        position: "absolute",
        right: "calc(50vw -  87px)",
        zIndex: 100,
        top: "5px",
        cursor: "pointer",
      }}
    >
      <Chip
        sx={{
          backgroundColor: "#F5005780",
          "& .MuiChip-deleteIcon": {
            color: "#ffffff50",
            ":hover": {
              color: "#ffffff50",
            },
          },
          color: "white",
        }}
        icon={
          <img
            src="https://www.buymeacoffee.com/assets/img/BMC-btn-logo.svg"
            alt="Buy me a coffee"
            color="white"
          />
        }
        label={`Buy me a coffee`}
        onDelete={handleRemoveCoffee}
        onClick={handleClick}
      />
    </Box>
  ) : null;
}
